export default __webpack_public_path__ + "static/media/thumb.cb004514.png";